<head>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css">
    </head>
    <body>
    <div class="bstart" (click)="onButtonGroupClick($event)">
    <button  type="button" class="btn btn-primary mr-3 shadow-none" (click)="openModal()">{{'START DIAGNOSIS'|translate}}</button>
    <button routerLink="/vehicleSessions" type="button" class="btn btn-primary mr-3 shadow-none" >{{'RESUME SESSION'|translate}}</button>
    </div>
    <div class="oneline"><span>{{'Here you will find the latest information available relating to FordEtis IDS'|translate}}.</span></div>
    <div class="row">
        <div class="column1" >
        <div class="panel1">
                <div class="box">
                    <div class="panel-heading">
                    <i class="fa fa-plus-square"(click)="isShow=!isShow" *ngIf="!isShow" title="Click to expand"></i>
                    <i *ngIf="isShow" class="fa fa-minus-square" (click)="isShow=!isShow" title="Click to collapse"></i></div>
                        <div class="panel-body align1" >
                            <h2>Diagnostic Vehicle Applicability</h2>
                            <div *ngIf="isShow">
                                <span>
                                    Use of FordEtis IDS is Mandatory on all vehicles for all European electrical and mechanical warranty repairs (including Ford Protect Optional Extended Warranty - where applicable). For details of exceptions to ETIS IDS connection refer to:
                                    <a href="/warranty/warrantyCommsView.do?uid=G1249765&amp;number=WB%2045&amp;year=2009&amp;type=bulletin&amp;language=en&amp;country=GB">
                                    European WB 45 / 2009 Warranty and FordEtis IDS</a>
                                </span>
                            </div> 
                        </div>
                </div>
                <div class="box1">
                <div class="panel-heading">
                    <i class="fa fa-plus-square"(click)="isShow1=!isShow1" *ngIf="!isShow1" title="Click to expand"></i>
                    <i *ngIf="isShow1" class="fa fa-minus-square" (click)="isShow1=!isShow1" title="Click to collapse"></i></div>
                    <div class="panel-body align1">
                        <h2>Recommended Environment</h2>             
                        <div *ngIf="isShow1">
                            <span>
                                <div>To ensure best results and error free diagnosis and repair when using FordEtis (FDRS), FordEtis IDS, or IDS standard please make sure that you use the specification described below.</div>
                                <div id="currentlyRecommended"><b>Currently Recommended:</b></div>
                                <table border="0" cellspacing="0" cellpadding="0" class="table__thin">
                                <tbody><tr>
                                <td>Operating System:</td>
                                <td>[Windows 10, Windows LTSC]</td>
                                </tr>
                                <tr>
                                <td>Operating System Version:</td>
                                <td>LTSC</td>
                                </tr>
                                <tr>
                                <td>Browser version:</td>
                                <td>Internet Explorer 11.0</td>
                                </tr>
                                <tr>
                                <td>RAM:</td>
                                <td>8 GB</td>
                                </tr>
                                <tr>
                                <td>Available RAM:</td>
                                <td>1 GB</td>
                                </tr>
                                <tr>
                                <td>Available disk space:</td>
                                <td>&gt;1 GB</td>
                                </tr>
                                <tr>
                                <td>Bandwidth:</td>
                                <td>&gt;8.0 Mbps</td>
                                </tr>
                                <tr>
                                <td>Total JVM memory:</td>
                                <td>30 MB</td>
                                </tr>
                                <tr>
                                <td>JVM Version:</td>
                                <td>1.8.0_151</td>
                                </tr>
                                </tbody></table>
                                </span>
                    </div>
                </div>
                </div>  
                <div class="box3">
                    <div class="panel-heading">
                    <i class="fa fa-plus-square"(click)="isShow3=!isShow3" *ngIf="!isShow3" title="Click to expand"></i>
                    <i *ngIf="isShow3" class="fa fa-minus-square" (click)="isShow3=!isShow3" title="Click to collapse"></i></div>
                        <div class="panel-body align1" >
                            <h2>DVD &amp; Software Updates</h2>
                            <div style="display: block;"*ngIf="isShow3">
                            <span>Latest software framework version available to download: 20210407.2</span>
                            <span>Latest software component version available to download: 20210407.1</span>
                            <span>Prior to installing the FordEtis IDS Software Image, ensure all session files have been sent back to Ford by selecting the "Diagnostic session(s) ready to send, click here. " link within FordEtis IDS. Close FordEtis and Web Server. Uninstall the existing FordEtis IDS program using the uninstall.exe program located in C:/Users/Public/FordEtis. Then delete the FordEtis folder including the contents. </span>
                            <span>If installing on a new computer or reinstalling FordEtis IDS use the 10/2019 "Current FordEtis IDS Software Image Download" link located on the FordEtis Help Page. During this download it is recommended that your computer is connected to the network by an Ethernet cable to reduce download time. Once downloaded right click the ETISIDSImage.zip and select "extract files" by using WinRAR or 7-Zip (available on the internet), then select the Setup.exe file and install in the usual way. The downloaded file can be copied and used on as many computers as desired.</span>
                            <span>In order to use FordEtis/FordEtis IDS with the Sync module you will require the following driver to be installed:
                            <a href="http://etis.dealerconnection.com/fileserve.do?file=/shared/SBOOTDriverSetup64.exe">Driver Download</a> </span>
                        </div> 
                        </div>
                </div>
        </div>
        </div>
        <div class="column2" >
        <div class="panel2">
                <div class="box6">
                    <div class="panel-heading">
                        <i class="fa fa-plus-square"(click)="isShow6=!isShow6" *ngIf="!isShow6" title="Click to expand"></i>
                        <i *ngIf="isShow6" class="fa fa-minus-square" (click)="isShow6=!isShow6" title="Click to collapse"></i></div>
                            <div class="panel-body align1" >
                                <h2>DVD &amp; Software Updates</h2>
                                <div style="display: block;"*ngIf="isShow6">
                                    <div>
                                        <ul>
                                        <span><li>Repair Validation Code (RVC). To minimise the risk of the RVC being misinterpreted, the letters <b>"S", "Z", "I" </b> and <b>"O"</b> are <b>not used</b>. So if you see a written character that looks like the letter <b>"S"</b>, it is in fact the number <b>5</b> (five). If a character looks like a number - it is a number.</li></span>
                                        <span><li>The "Get VIN" function within Etis-IDS is being improved. This is a continuation of system improvements to migrate to a more reliable and portable diagnostic solution.If certain prerequisite conditions are met (ignition switched on and VCM connected) the VIN will be retrieved from the vehicle between two and four seconds. If the vehicle fails to respond the Etis-IDS VIN field will be populated with "xxxxxxxxxxxxxxxxx" and the vehicle VIN will need to be manually entered.The following operating system and internet browser combinations are currently recommended when running FordEtis IDS.</li></span>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                </div>
                <div class="box8">
                    <div class="panel-heading">
                    <i class="fa fa-plus-square"(click)="isShow8=!isShow8" *ngIf="!isShow8" title="Click to expand"></i>
                    <i *ngIf="isShow8" class="fa fa-minus-square" (click)="isShow8=!isShow8" title="Click to collapse"></i></div>
                    <div class="panel-body align1" >
                        <h2>What's New! - FordEtis IDS Diagnostics</h2>
                        <div style="display: block;"*ngIf="isShow8">
                            <span>
                                <b>Diagnostic procedures published in the past two weeks:</b>
                                <div>
                                No updates are available at this time
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="box9">
                    <div class="panel-heading">
                    <i class="fa fa-plus-square"(click)="isShow9=!isShow9" *ngIf="!isShow9" title="Click to expand"></i>
                    <i *ngIf="isShow9" class="fa fa-minus-square" (click)="isShow9=!isShow9" title="Click to collapse"></i></div>
                        <div class="panel-body align1" >
                            <h2>Supporting Information</h2>
                                <div *ngIf="isShow9">
                                    <ul>
                                        <li><a href="/externalURL.do?url=http://www.ford-ids.com/extw">IDS Equipment site&nbsp;(www.ford-ids.com)</a></li>
                                        <li><a href="/training/elearning/view.do?variantId=977">eLearning course TC1011021C</a></li>
                                        <li><a href="/tsb/tsbView.do?regionalNumberYear=2010&amp;regionalNumberSequence=83&amp;language=en&amp;country=US">How to use FordEtis IDS - TSB 83/2010</a></li>
                                        <li><a href="/tsb/tsbView.do?regionalNumberYear=2010&amp;regionalNumberSequence=60&amp;language=en&amp;country=US">Hardware and Software Installation - TSB 60/2010</a></li>
                                        <li>
                                        
                                        <a href="/tsb/tsbView.do?regionalNumberYear=2013&amp;regionalNumberSequence=39&amp;language=en&amp;country=US">IDS Helpdesk contact change - TSB 39/2013</a>
                                        &nbsp;
                                        </li>
                                        <li><a href="/tsb/tsbView.do?regionalNumberYear=2009&amp;regionalNumberSequence=69&amp;language=en&amp;country=US">Technician Star Rating - TSB 69/2009</a></li>
                                        <li><a href="/tsb/tsbView.do?regionalNumberYear=2012&amp;regionalNumberSequence=19&amp;language=en&amp;country=US">Flexnet Introduction - TSB 19/2012</a></li>
                                        <li><a href="/help/faq.do">Systems and Connectivity Help</a></li>
                                        <li><a href="/externalURL.do?url=http://ford-ids.com/wvcm">IDS VCM: Wireless functionality</a></li>
                                        </ul>
                                </div>
                        </div>
                </div>    
        </div>
        </div>
    </div>
    </body>
    <router-outlet></router-outlet>
            
    